import * as React from "react";

function WaveIcon(props) {
  return (
    <svg
      width={15}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.5 8.77V11a1 1 0 001 1v0a1 1 0 001-1V6a1 1 0 011-1v0a1 1 0 011 1v5a1 1 0 001 1v0a1 1 0 001-1V6a1 1 0 011-1v0a1 1 0 011 1v5a1 1 0 001 1v0a1 1 0 001-1V6a1 1 0 011-1v0a1 1 0 011 1v2.154"
        stroke={props.color || "#000"}
      />
    </svg>
  );
}

export default WaveIcon;
